var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAugmenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(-692 -4226)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 61,
    cy: 61,
    r: 61,
    transform: "translate(692 4226)",
    fill: "rgba(30,194,138,0.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "increase",
    d: "M19.991,47.963a41.731,41.731,0,0,0,4.876-.551V62.655H19.991ZM0,62.655H4.876V48.028H0ZM10,48.028V62.655h4.876V48.028ZM49.855,62.655H54.73V25.593a41.472,41.472,0,0,1-4.876,7.32Zm-9.995,0h4.875V38.089a41.619,41.619,0,0,1-4.875,3.574Zm-10-16.434V62.655H34.74V44.394c-.262.117-.524.233-.789.345A41.819,41.819,0,0,1,29.864,46.221ZM52.136.332,41.792,10.675l3.448,3.448,4.288-4.288A32.1,32.1,0,0,1,17.674,38.276H0v4.876H17.674A36.693,36.693,0,0,0,43.791,32.334,36.654,36.654,0,0,0,54.459,9.551l4.486,4.486,3.448-3.448Zm0,0",
    transform: "translate(721.804 4251.773)",
    fill: "#58a596"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAugmenter);
export default __webpack_public_path__ + "static/media/augmenter.aa102e8bcfa5364e2f23d3c2c9c4829e.svg";
export { ForwardRef as ReactComponent };